import { IFieldInstance } from "../../types/fieldInstance.interface";
import { getChildFields } from "./getChildFields";

export function getFieldProperties(
  field: IFieldInstance,
  relatedListName?: string
) {
  let toggleBoxField: any[] = [];
  let checkboxField: any[] = [];
  let secondBPField: any[] = [];
  let textField: any[] = [];
  if (field.childFieldIds.length > 0) {
    toggleBoxField = getChildFields(
      field.childFieldIds,
      "Togglebox",
      relatedListName
    );
    textField = toggleBoxField[0]
      ? getChildFields(toggleBoxField[0].childFieldIds, "Text", relatedListName)
      : [];
    checkboxField = getChildFields(
      field.childFieldIds,
      "Checkbox",
      relatedListName
    );
    secondBPField = checkboxField[0]
      ? getChildFields(
          checkboxField[0].childFieldIds,
          "SecondaryBPField",
          relatedListName
        )
      : [];
  }

  const showToggleBox = !!toggleBoxField && toggleBoxField.length > 0;
  const typeControlName = toggleBoxField.length && toggleBoxField[0].fieldName;
  const typeControlLabel =
    toggleBoxField.length && toggleBoxField[0].fieldLabel;
  const inputName = textField.length && textField[0].fieldName;
  const secondaryBPFieldName = secondBPField.length
    ? secondBPField[0].fieldName
    : "";
  const checkboxFieldName = checkboxField.length
    ? checkboxField[0].fieldName
    : "";
  const checkboxLabel = checkboxField.length ? checkboxField[0].fieldLabel : "";

  return {
    toggleBoxField,
    checkboxField,
    secondBPField,
    textField,
    showToggleBox,
    typeControlName,
    typeControlLabel,
    inputName,
    secondaryBPFieldName,
    checkboxFieldName,
    checkboxLabel,
  };
}
